import { useLayoutEffect, useRef } from "react";
import { prefersReducedMotion } from "./useReducedMotion";

/** Fade + 12px rise on mount (400ms ease-out). Re-runs when `key` changes (e.g. pathname). */
export function usePageTransition<T extends HTMLElement>(key?: unknown) {
  const ref = useRef<T>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || prefersReducedMotion() || typeof el.animate !== "function") return;
    const anim = el.animate(
      [
        { opacity: 0, transform: "translateY(12px)" },
        { opacity: 1, transform: "none" },
      ],
      { duration: 400, easing: "cubic-bezier(.2,.8,.2,1)" },
    );
    return () => anim.cancel();
  }, [key]);
  return ref;
}
